const NUMBER = String.raw`(\d+(?:\.\d+)?)`;
const NUMBER_THEN_X = new RegExp(`${NUMBER}\\s*x`, "i");
const X_THEN_NUMBER = new RegExp(`x\\s*${NUMBER}`, "i");
const ANY_NUMBER = new RegExp(NUMBER, "g");

/**
 * The leverage multiplier in a leverage field: "10x", "X10", "10", 10 → 10;
 * "5-10x" → 10; "1:10" → 10. Undefined when there is no positive number.
 */
export const parseLeverage = (value: unknown): number | undefined => {
  if (typeof value === "number")
    return Number.isFinite(value) && value > 0 ? value : undefined;
  const text = String(value ?? "");
  const match =
    NUMBER_THEN_X.exec(text)?.[1] ??
    X_THEN_NUMBER.exec(text)?.[1] ??
    text.match(ANY_NUMBER)?.pop();
  const leverage = parseFloat(match ?? "");
  return leverage > 0 ? leverage : undefined;
};
